// API Configuration
// This file centralizes the API URL configuration for the application

const config = {
  // Backend API URL - uses environment variable or defaults to localhost
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000'
};

export default config;

